import React from 'react'
import { components } from 'react-select'
import styled from 'styled-components'

import { ReactComponent as BriefcaseIcon } from '@/assets/svgs/briefcase.svg'
import { IconGenerator } from '@/components/uikit/IconGenerator'
import {
  OptionContainer,
  OptionLabel,
} from '@/components/uikit/Select/components/styles'
import { theme } from '@/theme'
import type { OptionType } from '@/UIkit/PlaceAutocomplete/types'

import type { OptionProps } from 'react-select'

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`

const OptionContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

export const Option = (props: OptionProps<OptionType>) => {
  const { data, isSelected, isMulti, label } = props
  const isOffice = data.isOffice

  return (
    <components.Option {...props}>
      <OptionContainer>
        <OptionContent>
          {isOffice && (
            <IconWrapper>
              <IconGenerator
                iconComponent={BriefcaseIcon}
                width={20}
                height={20}
                color={theme.colors.altoVitaMain}
              />
            </IconWrapper>
          )}
          <OptionLabel $isSelected={isSelected} $isMulti={isMulti}>
            {label}
          </OptionLabel>
        </OptionContent>
      </OptionContainer>
    </components.Option>
  )
}
